import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { AlertService } from '@core/services/alert.service';
import { DinamicaGeneraleService } from '@shared/dinamica-generale/services/dinamica-generale.service';
import { RoutePath } from '@shared/route-path.enum';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
	constructor(
		private alertService: AlertService,
		private authService: AuthService,
		private router: Router,
		private dgService: DinamicaGeneraleService
	) {}
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((err) => {
				if (err.status === 401) {
					const dgError = err.error && (err.error.step === 'base_jwt' || err.error.step === 'company_jwt');
					if (dgError) {
						this.dgService.clearJwtData();
					} else {
						return this.alertService
							.openModal({
								title: 'sf.common.errors.not_authorized.title',
								description: 'sf.common.errors.not_authorized.description',
								error: true,
							})
							.afterClosed()
							.pipe(
								tap(() => {
									this.authService.clearAuthData();
									this.router.navigate([RoutePath.AUTH, RoutePath.LOGIN]);
								})
							);
					}
				}
				return throwError(() => err);
			})
		);
	}
}
